import { colors } from '@monorepo/theme'
import styled from 'styled-components'

// Storefront-faithful look (copied from storefront/src/pages/resources/styles.ts)
// with admin-only overlay additions (edit button, status badge).

export const GalleryBackground = styled.div`
  background-color: #e7e9ec;
`

export const FileContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  /* Constrain to one full row (3 tiles: 3*400 + 2*28px = 1256px) and center
     that block; align-items: flex-start keeps every label and row (2 or 3
     tiles) sharing the same left edge. Mirrors the storefront. */
  align-items: flex-start;
  /* calc keeps 20px side gutters on screens narrower than the block */
  width: calc(100% - 40px);
  max-width: 1256px;
  margin: 0 auto;
  padding: 1px 0 60px;
`

export const Header = styled.h1`
  margin-top: 50px;
  margin-bottom: 50px;
  width: 50%;
  align-self: center;
  text-align: center;
  font-family: PFDINText;
  font-weight: 700;
  font-size: 36px;
  color: ${colors.black};
`

export const HeaderAlt = styled.span`
  font-family: Jubilat;
  font-size: 42px;
  font-style: italic;
`

export const CategoryContainer = styled.div`
  margin-bottom: 60px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const CategoryTitle = styled.div`
  color: ${colors.darkBlue};
  font-weight: 500;
  font-size: 20px;
  padding: 2px 0;
  margin-bottom: 10px;
`

export const CategoryItems = styled.div``

export const ResourceContainer = styled.div``

export const ResourceList = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 28px;
  flex-basis: 100%;
  margin-bottom: 20px;
  list-style: none;
  padding: 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const ResourceListItem = styled.li`
  background-color: ${colors.white};
  align-self: flex-start;
  display: flex;
  flex-direction: row;
  padding: 18px 24px 12px;
  position: relative;
  width: 400px;
  height: 225px;
`

export const FileInformation = styled.div`
  background-color: ${colors.white};
  width: 100%;
`

export const FileTitle = styled.p`
  font-family: PFDINText;
  font-size: 20px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${colors.darkBlue};
  line-height: 20px;
  height: 42px;
  overflow: hidden;
  margin-bottom: 8px;
`

export const FileDescription = styled(FileTitle)`
  color: ${colors.grey};
  font-family: PFDINText;
  font-size: 16px;
  font-weight: 400;
  text-transform: none;
  line-height: 22px;
  height: 66px;
  overflow: auto;
  margin-bottom: 44px;
`

export const ResourceLink = styled.a`
  color: ${colors.darkBlue};
  font-size: 18px;
  font-weight: 500;
  display: block;
`

// ----- admin overlay additions -----

export const EditButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  font-family: PFDINText;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: ${colors.white};
  background-color: #21528c;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`

export const EmptyMessage = styled.p`
  font-family: PFDINText;
  font-size: 16px;
  color: ${colors.grey};
  padding: 40px 0;
  text-align: center;
`

export const SpinnerContainer = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
`
